// Mapping between internal plan IDs and Stripe product/price IDs
export const stripePlans = {
  starter: {
    monthly_product_id: "prod_U75OMlWJrwDqnN",
    monthly_price_id: "price_1T8rE1B6f47cTf5R02iflQ2e",
    annual_product_id: "prod_U75vLJQ3Tbdpao",
    annual_price_id: "price_1T8rjKB6f47cTf5RdOHHb8sR",
  },
  professional: {
    monthly_product_id: "prod_U75O5AckctZtKw",
    monthly_price_id: "price_1T8rEAB6f47cTf5RT7Raz7Rq",
    annual_product_id: "prod_U75vC4OhHNZmSS",
    annual_price_id: "price_1T8rjLB6f47cTf5RTvIAGr7B",
  },
  business: {
    monthly_product_id: "prod_U75OLT2PvY6CNk",
    monthly_price_id: "price_1T8rEBB6f47cTf5RhZsY0LgQ",
    annual_product_id: "prod_U75vifaG1CWK4E",
    annual_price_id: "price_1T8rjMB6f47cTf5RoAAOJowH",
  },
} as const;

export type StripePlanId = keyof typeof stripePlans;

/** Reverse lookup: product_id → plan key (checks both monthly and annual products) */
export function planIdFromProduct(productId: string): StripePlanId | null {
  for (const [key, val] of Object.entries(stripePlans)) {
    if (val.monthly_product_id === productId || val.annual_product_id === productId) {
      return key as StripePlanId;
    }
  }
  return null;
}
